
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockchain-ai-development",
      function () {
        return require("private-next-pages/blockchain-ai-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockchain-ai-development"])
      });
    }
  